//hooks
import { useState } from "react";
import {
  StyledCell,
  StyledImagesSize,
  StyledCellUpload,
} from "../../components/styles/containers/Containers";
import ProgressBar from "./ProgressBar";
import { RemoveImg } from "./styles/styles";
import { BsTrash } from "react-icons/bs";
import { AiFillFilePdf, AiFillFileWord, AiFillFileText } from "react-icons/ai";
const PreviewImage = ({ image, onImageRemove }) => {
  const [isHovering, setIsHoovering] = useState(true);

  const onMouseEnter = () => {
    setIsHoovering(true);
  };

  const onMouseLeave = () => {
    setIsHoovering(true);
  };
  const handleDeleteImageKeyUp = (event, imageId) => {
    if (event.key == " ") {
      onImageRemove(imageId);
    }
  };
  return (
    <>
      <StyledImagesSize
        onTouchStart={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
      >
        {image.fileType && image.fileType.startsWith("image/") ? (
          <StyledCell
            id={image.id}
            src={image.preview_URL}
            alt="alt"
            tabIndex="-1"
            onClick={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {image.fileType === "application/pdf" ? (
              <AiFillFilePdf size="3rem" color="#e74c3c" />
            ) : image.fileType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              image.fileType === "application/msword" ? (
              <AiFillFileWord size="3rem" color="#2980b9" />
            ) : (
              <AiFillFileText size="3rem" color="#888" />
            )}
            <span
              style={{
                fontSize: "0.8rem",
                marginTop: 4,
                textAlign: "center",
                wordBreak: "break-all",
              }}
            >
              {image.fileName}
            </span>
          </div>
        )}
        {image.uploadProgress < 100 && (
          <StyledCellUpload>
            <ProgressBar max={100} progress={image.uploadProgress} />
          </StyledCellUpload>
        )}
        {isHovering && (
          <RemoveImg
            onClick={(e) => {
              e.stopPropagation();
              onImageRemove(image.id);
            }}
            onKeyUp={(e) => {
              e.stopPropagation();
              handleDeleteImageKeyUp(e, image.id);
            }}
          >
            <BsTrash
              style={{
                margin: "10px auto",
                display: "flex",
                alignSelf: "center",
              }}
              tabIndex="0"
              size="2rem"
            />
          </RemoveImg>
        )}
      </StyledImagesSize>
    </>
  );
};

export default PreviewImage;
